import BaseCustomControl from 'components/Map/Controls/CustomControls/BaseCustomControl';
import React from 'react';

interface Props {
	title?: string;
	handleClick?: () => void;
	active?: boolean;
}

const SlopeControl: React.FC<Props> = ({
	title,
	handleClick,
	active = false,
}) => {
	function toggleSlopeDirection() {}

	return (
		<BaseCustomControl
			icon="slopeDirection"
			title={title}
			handleControl={handleClick ?? toggleSlopeDirection}
			className="ol-slope"
			labelPosition="left"
			active={active}
		/>
	);
};

export default SlopeControl;
